import React, { useEffect } from "react";
import { Button as BootstrapButton } from "react-bootstrap";

import cx from 'classnames';

import styles from "./button.module.scss";
import _ from "lodash";

import calculateTextWidth from "../../../services/font.util";


interface ButtonProps {
  text?: string;
  icon?: string;
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary'| 'tertiary' | 'iconButton' | 'gradient';
  disabled?: boolean;
  className?: string;
  name?: string;
  onClick?: (e: any) => void;
}

const Button: React.FC<ButtonProps> = ({ text, icon, variant = 'secondary', disabled, className, children, name, onClick }) => {
  const textRef = React.useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (textRef.current && text) {
      const fontStyle = window.getComputedStyle(textRef.current, null);
      const font = fontStyle.getPropertyValue('font-family');
      const fontSize = fontStyle.getPropertyValue('font-size');
      const fontWeight = fontStyle.getPropertyValue('font-weight');

      const dimensions = calculateTextWidth(text, {
        font: font,
        fontSize: fontSize,
        fontWeight: fontWeight,
      });

      textRef.current.style.width = `${dimensions.width + 2}px`;
    }
  }, [text, icon]);

  return (
    <BootstrapButton className={cx(styles.button, styles[variant], className)} 
      onClick={onClick}
      disabled={disabled}
      name={name}
    >
      {icon && <i className={cx(styles.icon, icon)}></i>}
      {text && <span ref={textRef} className={styles.text}>{text}</span>}
      {children}
    </BootstrapButton>
  );
};

export default Button;